import { useState, useEffect, useContext } from "react";
import { CambioStatusContrato } from "../estatus-contrato-trabajo/cambioStatusContrato";
import { InputFileMultiple } from "../../components/formComponents/InputFileMultiple";
import { SolicitudDesvinculacion } from "../solicitud-desvinculacion/desvinculacion";
import { CambioDeInstalacion } from "../cambio-de-instalacion/cambioDeInstalacion";
import { InputFecha } from "../../components/formComponents/InputFecha";
import { CambioDeUnidad } from "../cambio-de-unidad/cambioDeUnidad";
import { DataContext, DataContextContractual } from "../../contextData/contextData";
import ErrorInput from "../../components/ui/ErrorInput";
import { useCambioCargo } from "./useCambioCargo";

export const CambioCargo = (props) => {
  const { tipo } = props;
  const { formik, posicionesLaborales, getDatos, submitCambioCargo } = useCambioCargo(tipo);
  const [documentos, setDocumentos] = useState([]);
  const { uno } = useContext(DataContext);
  const {setTipoSolicitud}= useContext(DataContextContractual);

  useEffect(() => {
    setTimeout(() => {
      if (uno["FECHA_INICIO_CAMBIO"]) {
        formik.setValues({ ...formik.values, fecha_inicio_cambio: uno["FECHA_INICIO_CAMBIO"] });
      }
      setTipoSolicitud(tipo);
    }, 100);
  }, [uno, tipo]);

  useEffect(() => {
    formik.setValues({ ...formik.values, documentosAdicionales: documentos });
  }, [documentos]);

  useEffect(() => {
    getDatos();
  }, []);

  return (
    <form id="formCambioCargo" onSubmit={submitCambioCargo} className="mb-4 d-flex flex-column gap-3">
      {![5].includes(tipo) && <InputFecha formik={formik} label="Fecha efectiva de cambio *" id="fecha_inicio_cambio" />}
      {[1].includes(tipo) && (
        <div>
          <div className="d-flex justify-content-between">
            <label htmlFor="cod_sap_nuevo_cargo">Nuevo cargo SAP *</label>
            {formik.errors.cod_sap_nuevo_cargo !== undefined && formik.touched.cod_sap_nuevo_cargo !== undefined && (
              <ErrorInput touched={formik.touched.cod_sap_nuevo_cargo} error={formik.errors.cod_sap_nuevo_cargo} />
            )}
          </div>

          <select
            disabled={!formik.values.fecha_inicio_cambio || formik.errors.fecha_inicio_cambio}
            id="inputCargo"
            className="form-select"
            name="cod_sap_nuevo_cargo"
            aria-label="Default select example"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.cod_sap_nuevo_cargo}
          >
            <option value="" key="456_a">Seleccione</option>
            {posicionesLaborales &&
              Object.keys(posicionesLaborales).map((el, indx) => {
                return (
                  <>
                    <option className="bg-dark text-white" value="" key={`${indx}'-ta'`}>
                      {" "}
                      {el}{" "}
                    </option>
                    {posicionesLaborales[el].map((ell, indxx) => {
                      return (
                        <option value={JSON.stringify(ell)} key={`${indxx}'-tt'`}>
                          {ell.MOES_COD_POSICION} {ell.MOES_DESCRIPCION_POSICION}
                        </option>
                      );
                    })}
                  </>
                );
              })}
          </select>
        </div>
      )}
      {[1, 2].includes(tipo) && <CambioDeUnidad formik={formik} tipo={tipo} />}
      {[3].includes(tipo) && <CambioDeInstalacion formik={formik} />}
      {[4].includes(tipo) && <CambioStatusContrato formik={formik} />}
      {[5].includes(tipo) && <SolicitudDesvinculacion formik={formik} />}

      {![2, 3, 4].includes(tipo) && (
        <InputFileMultiple
          formik={formik}
          label="Documentos adicionales"
          id="documentosAdicionales"
          files={documentos}
          setFiles={setDocumentos}
          requerido={[5].includes(tipo) ? false : true}
        />
      )}

      <div className="d-flex justify-content-end">
        <button
          type="button"
          onClick={() => {
            submitCambioCargo(formik.values);
          }}
          className="btn btn-primary"
        >
          Guardar
        </button>
      </div>
    </form>
  );
};
